import { createContext } from 'react'
type ContentBlockContextProps = {
    title: string
    seeAllUrl?: string
    labelColor: string
    iconClassName?: string
    width?: number
}
export const ContentBlockContext = createContext({} as ContentBlockContextProps)
